import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoGym from "../../Picture/logoKekes.png";
import PengeluaranGym1 from "../PengeluaranGym1";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const Owner=(props)=>{
    const url = props.url;
    const [pilihan,setPilihan]=useState("cashflow");
    const navigate = useNavigate();
    const location = useLocation();
    const [namaKop,setNamaKop]=useState("Cash Flow");
  const [popUpLogout,setPopUpLogout]=useState(false);
  
    // function klik ya
    const KlikYa=()=>{
 fetch(url + "/?op=logout", {
    credentials: "include",
  })
    .then((res) => res.json())
    .then((json) => {
      if (json === "logout") {
        navigate("/"); 
      }
    });

    }
    //function KlikTidak
    const KlikTidak=()=>{
 setPopUpLogout(false);
    }
    // function Klik Pilihan
    const KlikPilihan=(value)=>{
        if(value ==="cashflow"){
navigate("/owner");
setNamaKop("Cash Flow");
}
else if(value === "database"){
navigate("/owner/database");
setNamaKop("Database");
}
else if(value ==="pricing"){
    navigate("/owner/pricing");
    setNamaKop("Pricing");
}
else if(value ==="inout"){
    navigate("/owner/inout");
    setNamaKop("In Out");
}
        
        setPilihan(value);
        
    }
    // use effect location
     useEffect(() => {
    if (location.pathname.includes("database")) {
      setPilihan("database");
    } else if (location.pathname.includes("personalTrainer")) {
      setPilihan("personalTrainer");
    } else if (location.pathname.includes("pricing")) {
      setPilihan("pricing");
    }
    else if (location.pathname.includes("inout")) {
      setPilihan("inout");
    }else {
      setPilihan("cashflow");
    }
  }, [location.pathname]);

  // use effect
    useEffect(()=>{
        fetch(url + "/?op=cekSession", {
            credentials: "include", 
          })
          .then((response)=>response.json())
          .then((json)=>{
           
          if (json === "kosong") {
                navigate("/", { replace: true });
              }else if(json ==="gym2"){
    navigate("/gym2", { replace: true });
              }else if(json ==="gym1"){
    navigate("/gym1", { replace: true });
              }
          })
        },[])
return(
    <div className={style.containerAll}>
<div className={style.containerHeader}>
   
<div className={style.divJudul}>
Owner {namaKop}
 <div className={style.containerLogo}>
    <div onClick={()=>setPopUpLogout(true)} className={style.divLogo}>

    
    <img src={LogoGym}/>
    </div>
    <div style={{display:popUpLogout&&"none"}} className={style.divTulisanLogo}>
    Owner
    </div>
    <div style={{display:popUpLogout?"block":"none"}} className={style.divLogout}>
        <div className={style.judulDivLogout}>
Login dengan akun lain
        </div>
        <div className={style.isiDivLogout}>
<button onClick={()=>KlikYa()}>
    Ya
</button>
<button onClick={()=>KlikTidak()}>
    Tidak
</button>
        </div>
    </div>
 </div>
</div>
<div className={style.containerPilihan}>
<div style={{borderBottom:pilihan==="cashflow"?"solid 2px blue":""}} 
onClick={()=>KlikPilihan("cashflow")} className={style.divPilihan}>
Cash Flow
</div>
<div style={{borderBottom:pilihan==="database"?"solid 2px blue":""}} 
onClick={()=>KlikPilihan("database")} className={style.divPilihan}>
Database
</div>
<div style={{borderBottom:pilihan==="pricing"?"solid 2px blue":""}} 
onClick={()=>KlikPilihan("pricing")} className={style.divPilihan}>
Pricing
</div>
<div style={{borderBottom:pilihan==="inout"?"solid 2px blue":""}} 
onClick={()=>KlikPilihan("inout")} className={style.divPilihan}>
In Out
</div>

</div>
</div>
<div className={style.containerIsi}>
<Outlet/>
</div>
    </div>
)
}
export default Owner;